import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ModalCore } from "src/Pages/components";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { FormProducer } from "./FormProducer";
import { UseFeaturesFormProducer } from "./hook/UseFeaturesFormProducer";

interface IModalFormProducer {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalFormProducer = ({
  openModal,
  setOpenModal,
}: IModalFormProducer) => {
  const { userPerfil } = useAuthContext();
  const { resetInputs } = useResetInputs();

  const { handleSubmit, loading: loadingSubmit } = UseFeaturesFormProducer({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <>
      <ButtonCore
        disabled={
          userPerfil?.type_user === "USER" &&
          !userPerfil?.permissions.permissions.includes(
            valuesPermissions.PRODUCER.CREATE.id
          )
        }
        startIcon={<AddIcon />}
        title="Criar Produtor"
        onClick={() => setOpenModal(true)}
      />

      <ModalCore
        loadingSubmit={loadingSubmit}
        open={openModal}
        setOpen={setOpenModal}
        sxStyle={{ width: "1200px" }}
        title="Produtor"
        titleSubmit="Salvar"
        onChange={handleSubmit}
      >
        <FormProducer />
      </ModalCore>
    </>
  );
};
